import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for my designs
const myDesignsData = [{
  id: 'MD001',
  name: 'Western Field Pivot System',
  description: 'Main field irrigation system',
  date: 'Aug 05, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  lastModified: '2025-08-05',
  tags: ['Standard', 'Full-Circle']
}, {
  id: 'MD002',
  name: 'Eastern Linear System',
  description: 'Linear system for rectangular field',
  date: 'Jul 28, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  lastModified: '2025-07-28',
  tags: ['Linear', 'High-Flow']
}, {
  id: 'MD003',
  name: 'South Field Corner System',
  description: 'Corner arm addition to existing pivot',
  date: 'Jul 15, 2025',
  status: 'pending',
  model: 'Corner Arm',
  pivotCount: 1,
  specs: {
    length: '70.00 m',
    angle: 'N/A',
    area: '+8.00 ha',
    flow: '+18.00 l/s',
    pressure: '2.30 bar'
  },
  lastModified: '2025-07-15',
  tags: ['Corner', 'Upgrade']
}];
export function MyDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = myDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2891" data-mp="pj0hjodmbskc">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2892" data-mp="1n9dgz8gvzbq7">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2893" data-mp="1i9hejdnu7scr">
          <div className="flex justify-between items-start" data-id="element-2894" data-mp="1dae9vubrro5b">
            <div data-id="element-2895" data-mp="1dcr0evvlf6tz">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2896" data-mp="1992s2az5077o">
                My Designs
              </h3>
              <p className="text-4xl font-bold text-blue-600" data-id="element-2897" data-mp="1v976qbn1plp">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2898" data-mp="3tyig4y6z1htm">
              <PencilRulerIcon size={24} className="text-blue-600" data-id="element-2899" data-mp="29hizz373kvhz" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-2900" data-mp="2dikxnfld8zhu">
            Last updated: {new Date().toLocaleDateString()}
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2901" data-mp="2ige6kge207lt">
          <div className="flex justify-between items-start" data-id="element-2902" data-mp="2n9pc8e74qic5">
            <div data-id="element-2903" data-mp="2s80oswot76y2">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2904" data-mp="2s8jvfh90e8ws">Status</h3>
              <div className="mt-2" data-id="element-2905" data-mp="2x6ldbyup826o">
                <div className="flex justify-between text-sm mb-1" data-id="element-2906" data-mp="2x5iorxkumbtx">
                  <span data-id="element-2907" data-mp="317x7mhoipbl7">Active</span>
                  <span className="font-medium" data-id="element-2908" data-mp="319qcbrfkllqk">
                    {filteredDesigns.filter(d => d.status === 'active').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2909" data-mp="16v7e4122a4ec">
                  <span data-id="element-2910" data-mp="1btinybscwewk">Completed</span>
                  <span className="font-medium" data-id="element-2911" data-mp="1bujxucxmyvcp">
                    {filteredDesigns.filter(d => d.status === 'completed').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2912" data-mp="bkr2hyg39j1h">
                  <span data-id="element-2913" data-mp="bmln1bng7951">Pending</span>
                  <span className="font-medium" data-id="element-2914" data-mp="qi1i9jzrlb30">
                    {filteredDesigns.filter(d => d.status === 'pending').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-green-100 p-2 rounded-lg" data-id="element-2915" data-mp="3tza229e1yl0d">
              <UserIcon size={24} className="text-green-600" data-id="element-2916" data-mp="3oz5jmdtl3g7i" />
            </div>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2917" data-mp="7idvz7tiph3n">
          <div className="flex justify-between items-start" data-id="element-2918" data-mp="7kgy2q7y30oq">
            <div data-id="element-2919" data-mp="2r5oihbr05t4">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2920" data-mp="2qmbnf0yg7ly">Models</h3>
              <div className="mt-2" data-id="element-2921" data-mp="3b664icxpro0h">
                <div className="flex justify-between text-sm mb-1" data-id="element-2922" data-mp="3b5eb98rla2dd">
                  <span data-id="element-2923" data-mp="3684jhmgq9emd">Pivot CP600</span>
                  <span className="font-medium" data-id="element-2924" data-mp="1lqvggcr3v199">
                    {filteredDesigns.filter(d => d.model === 'Pivot CP600').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2925" data-mp="1qj523gl6tf5q">
                  <span data-id="element-2926" data-mp="1bu0hjsqx6yug">Linear</span>
                  <span className="font-medium" data-id="element-2927" data-mp="1grihitmym3qb">
                    {filteredDesigns.filter(d => d.model === 'Linear').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2928" data-mp="24hwacmddc6ly">
                  <span data-id="element-2929" data-mp="29f4wey1n0ush">Corner Arm</span>
                  <span className="font-medium" data-id="element-2930" data-mp="29e3jsp4z408n">
                    {filteredDesigns.filter(d => d.model === 'Corner Arm').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2931" data-mp="1zjuv6cj2crfr">
              <RulerIcon size={24} className="text-indigo-600" data-id="element-2932" data-mp="k0ghap1nwyqr" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2933" data-mp="2qp8u016ya35m">
        <div className="text-gray-700 font-medium" data-id="element-2934" data-mp="2lqp820scwrd9">
          {filteredDesigns.length} designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2935" data-mp="2gz720ybh80lf">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2936" data-mp="2c0m6hc76653b">
            <ListIcon size={16} className="mr-1" data-id="element-2937" data-mp="27wxxcp2w31fy" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2938" data-mp="22ymlk8t1agv3">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2939" data-mp="1t31n2kn6byq3" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2940" data-mp="3sdsyhivbkz6u">
            <FoldersIcon size={16} className="mr-1" data-id="element-2941" data-mp="3vxl36kw844rs" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2942" data-mp="8jfqs1mcfokm">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2943" data-mp="8m1z43h2683w" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2944" data-mp="3cxxhoaxsweth">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2945" data-mp="3gyzfcnc2kitc" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2946" data-mp="3lyvjcmkroa8w">
              No designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2947" data-mp="3qz05as4g1x6i">
          <table className="w-full" data-id="element-2948" data-mp="118mxvozv5mhh">
            <thead className="bg-gray-50" data-id="element-2949" data-mp="117ld2st1plmk">
              <tr data-id="element-2950" data-mp="167hi8vdhbj3p">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2951" data-mp="166y9o59py72c">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2952" data-mp="1rbs39agha9sk">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2953" data-mp="211la5y5oe0qh">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2954" data-mp="1w8s6zepuv0gi">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2955" data-mp="25zmt8j33q01y">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2956" data-mp="2f1322me9pu42">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2957" data-mp="pmoi0fe72vew">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2958" data-mp="2waymrxngjx60">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2959" data-mp="319070lwme2j2">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2960" data-mp="2niwq8agif110">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2961" data-mp="2rhlyxpqlrueb">
                    <div className="font-medium" data-id="element-2962" data-mp="2dimbglettljq">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2963" data-mp="2ik1xogsqpy3p">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2964" data-mp="24llrcqysi9m3">
                    <div className="flex items-center" data-id="element-2965" data-mp="28l49xg3528lr">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-2966" data-mp="2rmiec9544ck" />
                      <div data-id="element-2967" data-mp="39r0471k0ol0h">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-2968" data-mp="39pp0f1qknd9d">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2969" data-mp="34sgfwuhyax4y">
                    <div className="flex gap-2 text-xs" data-id="element-2970" data-mp="3sij2iv33jaw6">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2971" data-mp="1b6k6cqh8reo">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2972" data-mp="3jgjp0craioxz">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-2973" data-mp="280l85mpveym7">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2974" data-mp="24ifd2bjrknw9">
                    {design.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2975" data-mp="1zn05u2g9hq8t">
                    <StatusBadge status={design.status} data-id="element-2976" data-mp="2ehedj6udld86" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2977" data-mp="29jv1mdl5hcje">
                    <div className="flex space-x-2" data-id="element-2978" data-mp="1lsftu5alu30r">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2979" data-mp="1lr4sec4mt7ct">
                        <EyeIcon size={16} data-id="element-2980" data-mp="1gvpghpq6plj1" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2981" data-mp="1vk3qqlpxkc9m">
                        <EditIcon size={16} data-id="element-2982" data-mp="1qrsf4lltv218" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2983" data-mp="1qqhakjkk5q92">
                        <ShareIcon size={16} data-id="element-2984" data-mp="130wty7bvn52y" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2985" data-mp="1npzd08s3pnkd">
              No designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2986" data-mp="1isz6xxv94kt9">
      <div className="p-5 border-b border-gray-100" data-id="element-2987" data-mp="2p8jb2sk4kd0o">
        <div className="flex justify-between items-start" data-id="element-2988" data-mp="2u7co6jvi220b">
          <div data-id="element-2989" data-mp="2u9yw4kmayjj2">
            <div className="flex items-center" data-id="element-2990" data-mp="ikixh17n7ogu">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2991" data-mp="ij7lie41naen">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2992" data-mp="dnisktmj4rrb">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2993" data-mp="3ul8ij1w2uql">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2994" data-mp="3w0glwhotgmci">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2995" data-mp="3m1rc7c72q87c">
        <div className="flex items-center" data-id="element-2996" data-mp="3h3zc3uw9zfs2">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2997" data-mp="1k9mibv60l0tz" />
          <div data-id="element-2998" data-mp="1fbkvr09dqjdr">
            <div className="text-sm font-medium text-gray-900" data-id="element-2999" data-mp="1f8ypr5250bxn">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-3000" data-mp="1sakabi7lm7u7">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-3001" data-mp="1dfe3wu4lc70c">
          <div className="text-xs text-gray-500 flex items-center justify-end" data-id="element-3002" data-mp="1ic4mbo3vbeox">
            <CalendarIcon size={12} className="mr-1" data-id="element-3003" data-mp="14kzrczbg3akx" />
            {design.date}
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-3004" data-mp="19c81jxklmzz5">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-3005" data-mp="19chp7ei68v1o">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-3006" data-mp="uod7oduuupkh">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-3007" data-mp="zln4iekkq3ic">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-3008" data-mp="zjsisy1ha7d7">
              <RulerIcon size={12} className="mr-1" data-id="element-3009" data-mp="lmx7eyxr83tz" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3010" data-mp="pn7e6dtdey9w">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-3011" data-mp="719jr3sceh6d">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-3012" data-mp="21wru4mm6jwx">
              <PieChartIcon size={12} className="mr-1" data-id="element-3013" data-mp="g1oa4hk5ymgq" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3014" data-mp="b08purpt8jze">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-3015" data-mp="pw6i3ywm546c">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-3016" data-mp="kyep11k8fc0k">
              <DropletIcon size={12} className="mr-1" data-id="element-3017" data-mp="ypjj7o4tzc3i" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-3018" data-mp="uq292heglqs0">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-3019" data-mp="18mo7bti8lhmy">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-3020" data-mp="13rijuq96ruwr" data-mpi={index}>
              <TagIcon size={10} className="mr-1" data-id="element-3021" data-mp="1ageh63m766n" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-3022" data-mp="ad7s9cjyqe1g">
        <div className="flex space-x-2" data-id="element-3023" data-mp="ab4sw1wx78k2">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-3024" data-mp="f3xuwi1082sg">
            <EyeIcon size={14} className="mr-1" data-id="element-3025" data-mp="k1podgharwyr" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-3026" data-mp="p1caygj0mpk8">
            <EditIcon size={14} className="mr-1" data-id="element-3027" data-mp="t37cnm4uz4yj" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-3028" data-mp="y2sbzxnxxfbs">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3029" data-mp="y1qzrpv6umsh">
            <ShareIcon size={16} data-id="element-3030" data-mp="2uvvky9wd0il6" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-3031" data-mp="2ux6oc8lw7obr">
            <DownloadIcon size={16} data-id="element-3032" data-mp="2zuf6i971jsd0" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-3033" data-mp="2xa0hhmc5hqa6">
      {config.text}
    </span>;
}